import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import { flowRight } from 'lodash'
import { getLocale } from 'lib/utils/getLocale'

import VehicleProfileLogic from 'components/Vehicles/VehicleProfile/VehicleProfileLogic'
import Button from 'components/UI/Button'
import ErrorComponent from 'components/Errors/ErrorComponent'
import LoadingIndicator from 'components/LoadingIndicator'
import { GenericModalContext } from 'components/Modal/GenericModal/GenericModal'
import ErrorMessageContent from './ErrorMessageContent'
import { DevErrorViewContext } from 'components/Errors/DevErrorView'

const DEV_TEST_DATA = {
    action: 'softDelete',
}

const ConfirmDeleteVehicle = ({ history, appError }) => {
    const { t, i18n } = useTranslation('errors')
    const modalContext = useContext(GenericModalContext)

    let data = appError.data

    const devErrorContext = useContext(DevErrorViewContext)

    if (devErrorContext) {
        data = DEV_TEST_DATA
    }

    const { action, vehicleId } = data

    let message = t('errors:omanettix.10076.message')

    // read the delete vehicle confirmation message by action type
    if (action) {
        message = t([`errors:omanettix.10076.${action}.message`, 'errors:omanettix.10076.message'])
    }

    return (
        <VehicleProfileLogic>
            {(vehicleLogic) => {
                if (vehicleLogic.error) return <ErrorComponent error={vehicleLogic.error} container={false} />
                if (vehicleLogic.loading) return <LoadingIndicator />

                return (
                    <ErrorMessageContent
                        content={message}
                        actions={(
                            <>
                                <Button
                                    trackName="vehicleDelete"
                                    className="button button--delete"
                                    onClick={() => {
                                        vehicleLogic.deleteVehicle(vehicleId, true)
                                            .then(() => {
                                                history.push(`${getLocale(i18n.language) || '/'}`)
                                            })
                                    }}
                                    type="button"
                                >
                                    {t('vehicles:actions.deleteVehicle.ctaConfirm')}
                                </Button>
                                {modalContext && (
                                    <Button
                                        trackName="cancel"
                                        className="button button--secondary"
                                        onClick={modalContext.closeModal}
                                        type="button"
                                    >
                                        {t('common:cancel')}
                                    </Button>
                                )}
                            </>
                        )}
                    />
                )
            }}
        </VehicleProfileLogic>
    )
}

export default flowRight(
    withRouter,
)(ConfirmDeleteVehicle)
